exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  width: 1000px;\n  margin: 0 auto;\n  text-align: center; }\n  @media (max-width: 999px) {\n    .header {\n      width: 100%; } }\n  .header a {\n    color: #fff; }\n  .header nav {\n    border-width: 0 0 1px;\n    z-index: 1030;\n    min-height: 50px;\n    border: 1px solid transparent;\n    text-transform: uppercase;\n    font-size: 1.2em; }\n    .header nav ul {\n      display: inline-block;\n      list-style-type: none;\n      padding: 1.7em 0 3em 0;\n      margin: 0; }\n      .header nav ul li {\n        display: inline;\n        margin: 0 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/components/header/header.component.scss
// module id = ../../../../../src/app/components/header/header.component.scss
// module chunks = 0